import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IPlan, IShareholder } from '@appShared/interfaces/[Model-based]';
import { CommonService } from '@appShared/services/common.service';
import {
   ConfirmModalComponent,
   ConfirmService,
   ConfirmTemplateDirective
} from '@appShared/components/confirm-modal-and-service';
import {
  ShareholderEditSectionData,
  ShareholderEditSection_,
  AdminService
} from '@appShared/services/admin.service';
import { ShareholderPlanEditModalComponent } from '../shareholder-plan-edit/shareholder-plan-edit-modal.component';
import { ToastrType } from '@appShared/services/toastr.service';

@Component({
  selector: 'app-shareholder-plan-list',
   templateUrl: './shareholder-plan-list.component.html',
   imports: [
      CurrencyPipe,
      ConfirmTemplateDirective,
      ConfirmModalComponent
   ]
})
export class ShareholderPlanListComponent implements OnInit {
  @Input() shareholder: IShareholder;
  @Input() canEdit: boolean;
  @Output() shareholderSectionUpdated = new EventEmitter();

  /* grid */
  plans: IPlan[] = [];
  isLoading: boolean;
  isDeleting: boolean;

  constructor(
    private _adminService: AdminService,
    private _commonService: CommonService,
    private _confirmService: ConfirmService,
    private _modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.isLoading = true;

    this._getPlans();
  }

  /*
   * private methods
   * */

  private _getPlans(): void {
    if (this.shareholder.id) {
      this._adminService
        .getPlans(this.shareholder.id)
        .then(plans => {
          this.plans = plans
        })
        .catch(() => {
          /* Do Nothing */
        })
        .finally(() => (this.isLoading = false))
    } else {
      this.plans = [];
    }
  }
  /*
   * public methods
   * */

  showPlan(plan?: IPlan): void {
    if (plan?.id || (this.shareholder.id && !this.shareholder.repurchaseOptionAsOf)) {
      plan = plan || ({ id: 0, shareholderId: this.shareholder.id } as IPlan);

      const shareholderPlanEditModalRef = this._modalService.open(
        ShareholderPlanEditModalComponent,
        { scrollable: true, windowClass: 'my-modal-lg' }
      );
      const shareholderPlanDetailEditComponent =
        shareholderPlanEditModalRef.componentInstance;
      shareholderPlanDetailEditComponent.shareholder = this.shareholder;
      shareholderPlanDetailEditComponent.plan = { ...plan };
      shareholderPlanDetailEditComponent.canEdit = this.canEdit;
      shareholderPlanDetailEditComponent.refreshGrid = () => {

        this._getPlans();

        this.shareholderSectionUpdated.emit({
          shareholderEditSection: ShareholderEditSection_.planInfo,
          shareholder: this.shareholder,
          refresh: true
        } as ShareholderEditSectionData);

        // this.itemStageUpdated.emit({
        //  setupStage: ItemSetupStage_.BasicData,
        //  item
        // } as ItemSetupStageData);
        // const updatedShareholder = {
        //  ...this.currentItem,
        //  discontinued: null,
        //  info: { isDiscontinued: false }
        // } as IShareholder;
        // this.shareholderSectionUpdated(updatedItem);
      };
    } else if (!this.shareholder.id) {
      this._commonService.messageUser(
        `You somehow got to this page without choosing
          a shareholder. Unable to Add Plan`,
        'Error Occurred!',
        ToastrType.error
      );
    } else {
      this._commonService.messageUser(
        `${this.shareholder.info.displayName} has
        a repurchase option term commencement date.<p>Correct this issue before proceeding.</p>`,
        'Repurchase Option!',
        ToastrType.error
      );
    }
  }

  deletePlan(plan: IPlan): void {
    this._confirmService
      .confirm({
        title: 'Deleting Stock Plan!',
        message: `You are deleting the ${plan.year} stock plan for:
            <p class='ps-3'><strong class='text-site-primary'>
              ${this.shareholder.info.displayName}
            </strong><p>
            Are you sure?`
      })
      .then(() => {
        this.isDeleting = true;

        this._adminService
          .deletePlan(plan)
          .then(() => {
            this._commonService.messageUser('Stock Plan deleted!');

            this._getPlans();

            this.shareholderSectionUpdated.emit({
              shareholderEditSection: ShareholderEditSection_.planInfo,
              shareholder: this.shareholder,
              refresh: true
            } as ShareholderEditSectionData);
          })
          .catch(() => {
            /* Do Nothing */
          })
          .finally(() => setTimeout(() => (this.isDeleting = false), 500));
      })
      .catch(() => {
        /* Do Nothing */
      });
  }
}
